import React from 'react';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import {useServerDelete} from 'features/server/model/useServerMutations';
import ConfirmModal from 'shared/ui/Modal/ConfirmModal/ConfirmModal';
import IServerOutput from 'features/server/model/Server/IServer';

interface IServerDeleteModalProps {
    item: IServerOutput,
    open: boolean;
    handleClose: () => void;
}

const ServerDeleteModal: React.FC<IServerDeleteModalProps> = ({ item, open, handleClose }) => {
    const {remove, isLoading} = useServerDelete({uuid: item.uuid, handleClose});

    return (
        <ConfirmModal
            variant="delete"
            open={open}
            handleClose={handleClose}
            header={t`Удаление сервера`}
            title={<Trans id="modal.server.delete.title" message="Вы уверены, что хотите удалить сервер"/>}
            name={item.name}
            confirmText={t`Удалить`}
            onConfirm={remove}
            isLoading={isLoading}
        />
    );
};

export default ServerDeleteModal;
